var map = {
	"./poker-c01.svg": "6072",
	"./poker-c02.svg": "c139",
	"./poker-c03.svg": "e1ea",
	"./poker-c04.svg": "e987",
	"./poker-c05.svg": "5144",
	"./poker-c06.svg": "e989",
	"./poker-c07.svg": "9467",
	"./poker-c08.svg": "b041",
	"./poker-c09.svg": "4a99",
	"./poker-c10.svg": "94af",
	"./poker-c11.svg": "065b",
	"./poker-c12.svg": "197c",
	"./poker-c13.svg": "a8d3",
	"./poker-d01.svg": "470c",
	"./poker-d02.svg": "a32a",
	"./poker-d03.svg": "bbe6",
	"./poker-d04.svg": "2343",
	"./poker-d05.svg": "f561",
	"./poker-d06.svg": "7976",
	"./poker-d07.svg": "a10b",
	"./poker-d08.svg": "3dbb",
	"./poker-d09.svg": "54ca",
	"./poker-d10.svg": "526c",
	"./poker-d11.svg": "fcd2",
	"./poker-d12.svg": "9386",
	"./poker-d13.svg": "0615",
	"./poker-h01.svg": "0b04",
	"./poker-h02.svg": "e5c3",
	"./poker-h03.svg": "22d4",
	"./poker-h04.svg": "06d7",
	"./poker-h05.svg": "4e5c",
	"./poker-h06.svg": "fe46",
	"./poker-h07.svg": "1cae",
	"./poker-h08.svg": "150b",
	"./poker-h09.svg": "182a",
	"./poker-h10.svg": "35b9",
	"./poker-h11.svg": "0b40",
	"./poker-h12.svg": "8e6e",
	"./poker-h13.svg": "d9e7",
	"./poker-s01.svg": "7483",
	"./poker-s02.svg": "d3d5",
	"./poker-s03.svg": "6646",
	"./poker-s04.svg": "3889",
	"./poker-s05.svg": "9900",
	"./poker-s06.svg": "4edf",
	"./poker-s07.svg": "3885",
	"./poker-s08.svg": "9f80",
	"./poker-s09.svg": "3d52",
	"./poker-s10.svg": "0c1e",
	"./poker-s11.svg": "08d7",
	"./poker-s12.svg": "3625",
	"./poker-s13.svg": "c319"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d856";